import React from 'react';
import { connect } from 'react-redux';
import { ToastContent } from 'chameleon/ui-stack/ui/toast';

const ToastContentWrapper = ({ autoCloseFF }) => (
  <ToastContent autoClose={autoCloseFF} />
);

const mapStateToProps = ({ featureFlag }) => ({
  autoCloseFF: featureFlag.toast_notification_autoclose,
});
export default connect(mapStateToProps)(ToastContentWrapper);
